// extracted by mini-css-extract-plugin
export default {"modalFormatNotAvailableContainer":"kOis0c5Ojx4M6jGUliMw","buttonsContainer":"HjV9wvKw96fOTWvTYwm2","buttonKnowMore":"cUaK7KvsPJjqE_DS61o5"};